import { organizationEndpoints } from '@/api/endpoints';
import type { FetcherService } from '@/services/abstract/FetcherService';
import { OrganizationService } from '@/services/abstract/OrganizationService';
import type { CoturnCredentials } from '@/types/organization/CoturnCredentials';

/**
 * Implementation of organization service for organization-related operations
 *
 * Provides functionality for:
 * - Retrieving TURN server credentials for WebRTC
 *
 * @see OrganizationService
 */
export class OrganizationServiceImpl extends OrganizationService {
  /**
   * Creates an instance of OrganizationServiceImpl
   * @param fetcher - Service for making HTTP requests to the backend
   */
  constructor(private readonly fetcher: FetcherService) {
    super();
  }

  /**
   * Retrieves time-limited coturn credentials for WebRTC TURN server authentication
   * @endpoint GET /private/v1/organizations/{id}/coturnCredentials
   * @param organizationId - The organization's unique identifier
   * @returns CoturnCredentials with username, password, ttl, and server URLs
   * @throws UnauthorizedError if user is not authenticated
   * @throws ForbiddenError if user is not a member of the organization
   */
  async getCoturnCredentials(organizationId: string): Promise<CoturnCredentials> {
    return await this.fetcher.get<CoturnCredentials>(
      organizationEndpoints.getCoturnCredentials(organizationId)
    );
  }
}
